import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@docma-mm-core/config/config.service';
import { BasedataService } from '@docma-mm-core/shared/basedata.service';
import { Structure } from '@docma-mm-core/structure/structure';
import { Observable, catchError, map, of, tap, timeout } from 'rxjs';
import { Plan, PlanData, PlanMetadata } from './plan';
import { Project } from '@docma-mm-core/project/project';
import { BpApiService } from '../../bp-common/bp-api.service';



@Injectable()
export class PlanService extends BasedataService {

  private planUrl = '/plans';
  private structureUrl = '/structures/';
  private metaDataUrl = '/attachments/';

  constructor(private http: HttpClient,private bpApiService: BpApiService,configService: ConfigService) {
    super(configService);
  }

  private getPlansUrl(structureId: number) {
    return super.getFullUrl(this.structureUrl + structureId + this.planUrl);
  }

  private getPlanMetaDataUrl(fileId: number) {
    return super.getFullUrl(this.metaDataUrl + fileId + '/tiles');
  }

  getPlans(project: Project, structures: Structure[]): Observable<PlanData[]> {

   if (project.BPConnected) {
     const structuresByUid: { [Uid: string]: Structure } = Object.fromEntries(structures.map(m => [m.UniqueId, m]));

     return this.bpApiService.getPlans(project.MyDocmaUid)
       .pipe(
         map(bpPlans => {
           return (bpPlans || []).map(bpPlan => {
               let structureId: number;
               if (isNaN(+bpPlan.structureId) && structuresByUid.hasOwnProperty(bpPlan.structureId)) {
                 structureId = structuresByUid[bpPlan.structureId].Id
               } else if (isNaN(+bpPlan.structureId) && bpPlan.structureId == project.MyDocmaUid) {
                 structureId = project.Structure.Id;
               } else {
                 structureId = +bpPlan.structureId;
               }

               return ({
                 Id: bpPlan.id,
                 Description: bpPlan.description,
                 Structure: {
                   Id: structureId,
                   StructurePath: bpPlan.structurePath
                 },
                 FileName: bpPlan.activeVersion?.filename,
                 BpPlan: bpPlan
               } as PlanData);
             }
           );
         })
       )
   }


    const structureId =  project.Structure.Id;
    const endpoint = this.getPlansUrl(structureId);



    let httpParams = new HttpParams();

    httpParams = httpParams.set('isActive', 'true');

    return this.http
      .get<PlanData[]>(endpoint, {headers: this.getHeaders(), params: httpParams})
      .pipe(catchError(e  => this.handleError(e)));
  }

  getPlanMetaData(plan: PlanData): Observable<PlanMetadata> {

    if (plan.BpPlan) {

      return of({
        ImageHeight: plan.BpPlan.activeVersion.renderHeight,
        ImageWidth: plan.BpPlan.activeVersion.renderWidth,
        MaxZoomLevel: plan.BpPlan.activeVersion.maxLevel,
        TilesUrl: plan.BpPlan.activeVersion.tilesUrl + '/{z}/{x}_{y}.jpg'

      } as PlanMetadata)
    }

    const fileId = +plan.Id;
    const endpoint = this.getPlanMetaDataUrl(fileId);


    return this.http
      .get<PlanMetadata>(endpoint, {headers:  this.getHeaders()})
      .pipe(
        map(md=> {
          md.TilesUrl =  this.getFullUrl(`/attachments/${fileId}/tiles/{z}/{x}/{y}`);
          return md;
        }),
        catchError(e =>  this.handleError(e))
      );
  }


  getStructureChildIds(node: Structure, childIds: number[]) {
    node.Children.forEach((child) => {
      childIds.push(child.Id);
      this.getStructureChildIds(child, childIds);
    });
  }


  planContainsText(plan: Plan, filterTextLowerCase: string) {
    return plan.data.Description?.toLowerCase().includes(filterTextLowerCase)    || plan.data.Structure?.Name1.toLowerCase().includes(filterTextLowerCase) ||
           plan.data.Structure?.Name2.toLowerCase().includes(filterTextLowerCase) || plan.data.StructurePath?.toLowerCase().includes(filterTextLowerCase)   ||
           plan.data.Remark?.toLowerCase().includes(filterTextLowerCase);
  }

}
